var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"px-0"},[_c('previewheader-component',{attrs:{"hideBack":"","title":_vm.$t('site.route.statistics')}}),_c('v-container',{staticClass:"px-0"},[_c('statisticsSummaryComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }